import IncentiveProgramTable from './incentiveProgramTable.container';

export default IncentiveProgramTable